export default "__VITE_ASSET__AsMlxLJP__"